module.exports = __webpack_public_path__ + "static/media/06_snapshot_graph.662bef21.png";